import { PAGE_NOT_FOUND } from 'containers/ErrorPage/constants';
export const errorHasOcurred = payload => ({
  type: PAGE_NOT_FOUND,
  payload,
});
